$font_family: Galano Grotesque, Segoe UI, sans-serif;

.container {
  position: relative;

  .searchIcon {
    width: 20.3px;
    height: 18.7px;
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translate(0px, -50%);
    cursor: pointer;
    @include themify($themes) {
      color: themed("main-primary");
    }
  }

  .searchCancelIcon {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translate(0px, -50%);
    cursor: pointer;
    @include themify($themes) {
      color: themed("main-primary");
    }
  }
}

.searchInput {
  font-family: $font_family !important;
  height: 40px;
  width: 100%;
  border-radius: 12px;
  outline: none;
  border: none;
  padding-left: 48px;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  user-select: none;
  @include themify($themes) {
    background-color: themed("neutral-tertiary");
    color: themed("main-primary");
    &::placeholder {
      color: themed("neutral-primary");
    }
  }

  &.collapsed {
    width: 0;
    padding-left: 30px;
    background: transparent;
  }
}

.clearSearchInputContainer {
  position: absolute;
  right: 0;
  height: 100%;
  top: 0;
  width: 40px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  @include themify($themes) {
    background: linear-gradient(to right, rgba(52, 152, 219, 0), themed("neutral-tertiary") 25%);
  }
}
